import React from "react";
import { Dialog, ExclamationCircleIcon, Flex, Text } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";
import { useStore } from "stores/Stores";

const ValidationDialog: React.FC = observer(() => {
    const { tasksStore } = useStore();

    const renderContent = () => {
        return (
            <Flex column hAlign="center" gap="gap.small">
                <ExclamationCircleIcon size="largest" />
                <Text size="largest" weight="bold">
                    {tasksStore.validationMessage}
                </Text>
            </Flex>
        );
    };

    return (
        <Dialog
            confirmButton="OK"
            content={renderContent()}
            open={tasksStore.validationMessage !== null}
            onConfirm={() => tasksStore.setValidationMessage(null)}
            closeOnOutsideClick
        />
    );
});

export default ValidationDialog;
